import * as React from "react";
import styled from "styled-components";

interface IProps {
    className?: string,
    glossaryEntries: string[]
}

interface IState {
}

class GlossaryEntries extends React.Component<IProps, IState> {
    public render() {
        return (
            <ul className={this.props.className}>
                {this.props.glossaryEntries.join(" ").replace(/[\{\}\"]/g, "").split(";").map(entry => (
                    <li key={entry}>
                        {entry}
                    </li>
                    ))
                }
            </ul>
        )
    };
}

export const StyledGlossaryEntries = styled(GlossaryEntries)`
  font-size: 1em;
  color: ${props => props.theme.lightColor};
  padding-inline-start: 0;
  margin-block-start: 0;
`;


// WEBPACK FOOTER //
// ./src/components/QuizBox/StyledGlossaryEntries.tsx